"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _input = _interopRequireDefault(require("../../input"));

var _tooltip = _interopRequireDefault(require("../../tooltip"));

var _context2 = require("../context");

var _utils = require("../utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var RadioSelect = function RadioSelect(_ref) {
  var _context;

  var rowData = _ref.rowData,
      rowIndex = _ref.rowIndex,
      isScrolling = _ref.isScrolling;

  var _useTable = (0, _context2.useTable)(),
      selectedRow = _useTable.selectedRow,
      disabledRows = _useTable.disabledRows,
      uniqueDataKey = _useTable.uniqueDataKey,
      getSelectionInputTooltip = _useTable.getSelectionInputTooltip,
      tableId = _useTable.tableId;

  var rowId = rowData[uniqueDataKey];
  var isChecked = selectedRow === rowId;
  var isDisabled = (0, _includes["default"])(disabledRows).call(disabledRows, rowId);
  var tooltip = (0, _react.useMemo)(function () {
    if ((0, _utils.isFunction)(getSelectionInputTooltip)) {
      var tooltipCbResult = getSelectionInputTooltip(rowData, rowIndex);
      return (0, _utils.getTooltipPropsFromCallback)(tooltipCbResult);
    }

    return null;
  }, [getSelectionInputTooltip, rowData, rowIndex]);

  var input = /*#__PURE__*/_react["default"].createElement(_input["default"], {
    id: (0, _concat["default"])(_context = "".concat(tableId, "-select-radio-")).call(_context, rowId),
    name: "".concat(tableId, "-select-radio"),
    type: "radio",
    checked: isChecked,
    className: "row-selection-input",
    disabled: isDisabled
  });
  /* istanbul ignore else */


  if (tooltip !== null && !isScrolling) {
    return /*#__PURE__*/_react["default"].createElement(_tooltip["default"], tooltip, input);
  }

  return input;
};

RadioSelect.propTypes = {
  rowData: _propTypes["default"].object,
  isScrolling: _propTypes["default"].bool,
  rowIndex: _propTypes["default"].number
};
var _default = RadioSelect;
exports["default"] = _default;